// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormGroup, ControlLabel } from 'react-bootstrap';
import DatePicker from '../../../../utils/FormWidgets/DatePicker';
import TimePicker from '../../../../utils/FormWidgets/TimePicker';

const StyledWrapper = styled.div`
  display: flex;

  .form-group {
    margin-right: 10px;
  }
`;

const EventBookableDate = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  startDateTime,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onOrderStateChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  eventDuration,
}) => {
  const onDateChange = event => {
    const m = moment(event).utcOffset(0);
    m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    onOrderStateChange('startDateTime', m.format());
  };

  const onTimeChange = event => {
    const m = moment(startDateTime).utcOffset(0);
    m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    m.add(event, 'seconds');
    onOrderStateChange('startDateTime', m.format());
  };

  const displayTime = time => {
    const m = moment(time).utcOffset(0).format('HH:mm:ss');
    const duration = moment.duration(m);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    return duration.valueOf() / 1000;
  };

  useEffect(() => {
    const m = moment(startDateTime).utcOffset(0);
    m.add(eventDuration, 'minutes');
    onOrderStateChange('endDateTime', m.format());
  }, [startDateTime, eventDuration]);

  return (
    <StyledWrapper>
      <FormGroup controlId='eventDate'>
        <DatePicker
          label='Date'
          value={new Date(startDateTime)}
          placeholder='TBD'
          handleChange={onDateChange}
        />
      </FormGroup>
      <FormGroup controlId='startTime'>
        <ControlLabel>Start Time</ControlLabel>
        <TimePicker
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          onChange={onTimeChange}
          value={displayTime(startDateTime)}
          minuteStep={30}
        />
      </FormGroup>
    </StyledWrapper>
  );
};

export default EventBookableDate;
